import { ShipmentDeliveryJobStatus } from "./shipment-delivery-job-status";
import { OrderStatus } from "../order-status";

export class ShipmentStatus {
  shipmentDeliveryStatus: Map<number, ShipmentDeliveryJobStatus> = new Map();
  isJobsRunning: boolean;
  isJobsGenerated: boolean;
  shipmentStatus: OrderStatus;
}
